import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Tabs, Tab, Accordion, AccordionContext, useAccordionButton, Form, Button, Card, Badge } from "react-bootstrap";
import GapsFields from '../../../components/Timeline/components/GapsFields';
import SuspectsFields from '../../../components/Timeline/components/SuspectsFields';
import AwaitingChartFields from '../../../components/Timeline/components/AwaitingChartFields';
import { formatDateWithMonthInTextAndHourMinutes, formatDate } from "../../../utils/util";
import { useManageVisitContext } from "./context/ManageVisitContext/ManageVisit.context";
import EQHErrorToast from "../../../components/EQHErrorToast";

const componentName = "missedOpportunities";

export const MissedOpportunities = ({ listType }) => {
  const manageVisitState = useManageVisitContext();
  const missedOpportunities = manageVisitState?.patient_get?.missedOpportunities || [];
  const [errors, setErrors] = useState([]);
  const [key, setKey] = useState('');
  const careGaps = missedOpportunities?.filter(activity => activity.type === "CARE_GAP");
  const suspectOpp = missedOpportunities?.filter(activity => activity.type === "SUSPECT");
  const awaitingChart = missedOpportunities?.filter(activity => activity.type === "AWAITING_CHART");

  function ArrowToggle({ children, eventKey, callback, activity, idx }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey),
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <Button variant="link" className="d-flex align-items-center justify-content-between text-dark text-decoration-none w-100" onClick={decoratedOnClick}>
        <div className="d-flex align-items-center gap-3">
          {!isCurrentEventKey
            ? <i className="fa fa-chevron-right" aria-hidden="true"></i>
            : <i className="fa fa-chevron-down" aria-hidden="true"></i>
          }
          <div className="d-block text-start">
            <h5 id={`${componentName}-eventTitle-${idx}`} className="d-flex justify-content-start align-items-center gap-2 m-0">
              <i id={`${componentName}-eventIcon-${idx}`} className={`text-danger fa-regular fa-circle-exclamation ${activity?.validation === "REJECTED" && activity?.status?.toUpperCase() === "OPEN" ? "" : "d-none"}`}></i>
              <span id={`${componentName}-eventTitleLabel-${idx}`} className="text-start">{activity?.displayName}</span>
            </h5>
            <div id={`${componentName}-eventDate-${idx}`}>{formatDateWithMonthInTextAndHourMinutes(activity?.date)}</div>
          </div>
        </div>
        {children}
      </Button>
    );
  }

  useEffect(() => {
    const conditions = {
      "awaitingchart": listType === "awaitingChart",
      "gaps": missedOpportunities?.filter(activity => activity.type === "CARE_GAP").length > 0,
    };
    const key = Object.keys(conditions).find(key => conditions[key]) || "suspects";
    setKey(key);
  }, [missedOpportunities, listType]);

  return (
    <>
      <Row>
        <EQHErrorToast
          errors={errors}
          handleClose={() => setErrors([])}
        />
        <Col>
          <Tabs id={`${componentName}-gapsSuspects`} activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 patientdrawer-tab-buttongroup">
            <Tab eventKey="gaps" title="Care Opportunity">
            {careGaps.length > 0 ? (
              careGaps.map((activity, idx) => (
                <Accordion eventKey={idx} key={idx} className="bg-white border rounded-3 p-3 mb-3">
                  <Card.Header eventKey={idx}>
                    <ArrowToggle componentName={componentName} eventKey={idx} idx={idx} activity={activity}>
                      <Badge id={`${componentName}-itemStatus-${idx}`} pill bg="success">{activity?.status}{activity?.type === "AWAITING_CHART" ? ": Awaiting Chart" : ""}</Badge>
                    </ArrowToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={idx}>
                    <Col>
                      <Row className="m-1 p-3">
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-visitLabel-${idx}`} className="form-label">Visit</label> 
                          <span id={`${componentName}-visitName-${idx}`}>{activity?.visitName}</span>
                        </Col>
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-dosLabel-${idx}`} className="form-label">Date of Service</label> 
                          <span id={`${componentName}-dateOfService-${idx}`}>{activity?.dateOfService ? formatDate(activity?.dateOfService) : 'No date available'}</span>
                        </Col>
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-practiceLabel-${idx}`} className="form-label">Rendering Practice</label> 
                          <span id={`${componentName}-practiceName-${idx}`}>{activity?.practiceName}</span>
                        </Col>
                      </Row>
                      <Row className="m-1 p-3">
                        <Col>
                          <Form.Group id={`${componentName}-DOS`}>
                            <GapsFields item={activity} setErrors={setErrors} />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Accordion.Collapse>
                </Accordion>
              ))
              ) : (
                <div className="my-3 mx-2">No Records Found</div>
              )}
            </Tab>
            <Tab eventKey="suspects" title="Suspect Condition">
              {suspectOpp.length > 0 ? (
                suspectOpp.map((activity, idx) => (
                <Accordion eventKey={idx} key={idx} className="bg-white border rounded-3 p-3 mb-3">
                  <Card.Header eventKey={idx}>
                    <ArrowToggle componentName={componentName} eventKey={idx} idx={idx} activity={activity}>
                      <Badge id={`${componentName}-itemStatus-${idx}`} pill bg="success">{activity?.status}{activity?.type === 'AWAITING_CHART' ? ": Awaiting Chart" : ""}</Badge>
                    </ArrowToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={idx}>
                    <Col>
                      <Row className="m-1 p-3">
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-visitLabel-${idx}`} className="form-label">Visit</label> 
                          <span id={`${componentName}-visitName-${idx}`}>{activity?.visitName}</span>
                        </Col>
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-dosLabel-${idx}`} className="form-label">Date of Service</label> 
                          <span id={`${componentName}-dateOfService-${idx}`}>{activity?.dateOfService ? formatDate(activity?.dateOfService) : 'No date available'}</span>
                        </Col>
                        <Col className="d-flex flex-column justify-content-start">
                          <label id={`${componentName}-practiceLabel-${idx}`} className="form-label">Rendering Practice</label> 
                          <span id={`${componentName}-practiceName-${idx}`}>{activity?.practiceName}</span>
                        </Col>
                      </Row>
                      <Row className="m-1 p-3">
                        <Col>
                          <Form.Group id={`${componentName}-DOS`}>
                            <SuspectsFields item={activity} setErrors={setErrors} />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Accordion.Collapse>
                </Accordion>
              ))
              ) : (
                <div className="my-3 mx-2">No Records Found</div>
              )}
            </Tab>
            <Tab eventKey="awaitingchart" title="Awaiting Chart">
              {awaitingChart.length > 0 ? (
                awaitingChart.map((activity, idx) => (
                <Accordion eventKey={idx} key={idx} className="bg-white border rounded-3 p-3 mb-3">
                  <Card.Header eventKey={idx}>
                    <ArrowToggle componentName={componentName} eventKey={idx} idx={idx} activity={activity}>
                      <Badge id={`${componentName}-itemStatus-${idx}`} pill bg="success">{activity?.status}{activity?.type === 'AWAITING_CHART' ? ": Awaiting Chart" : ""}</Badge>
                    </ArrowToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={idx}>
                    <Col>
                      <Row className="m-1 p-3">
                        <Col>
                          <Form.Group id={`${componentName}-DOS`}>
                            <AwaitingChartFields item={activity} setErrors={setErrors} />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Accordion.Collapse>
                </Accordion>
              ))
              ) : (
                <div className="my-3 mx-2">No Records Found</div>
              )}
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default MissedOpportunities;